// Fuente única de verdad para mapear tipo de trámite -> rutas de cada módulo.
// No asumir "todo lo que no es ART es RTI": hay que contemplar los 14 módulos
// (ART, RTI, Jubilación, PUAM, Plan de Pago, Reajuste, Reconocimiento, PNC, Amparo PNC, Pensión,
// Ganancias, Minusvalía, Declaratoria de Herederos, Amparo por mora).

// etiquetaCorta: la del chip del listado de clientes, donde entran varias por fila.
export const TIPOS_TRAMITE_PICKER = [
    { nombreBackend: 'ART', label: 'Trámite ART', etiquetaCorta: 'ART', icono: 'bi bi-heart-pulse', base: '/art' },
    { nombreBackend: 'RTI', label: 'Trámite RTI', etiquetaCorta: 'RTI', icono: 'bi bi-file-earmark-medical', base: '/rti' },
    { nombreBackend: 'JUBILACION', label: 'Trámite Jubilación', etiquetaCorta: 'Jubilación', icono: 'bi bi-person-vcard', base: '/jubilacion' },
    { nombreBackend: 'PUAM', label: 'Trámite PUAM', etiquetaCorta: 'PUAM', icono: 'bi bi-person-badge', base: '/puam' },
    { nombreBackend: 'PLAN_PAGO', label: 'Trámite Plan de Pago 27.705', etiquetaCorta: 'Plan de pago', icono: 'bi bi-cash-coin', base: '/plan-pago' },
    { nombreBackend: 'REAJUSTE', label: 'Trámite Reajuste de Haberes', etiquetaCorta: 'Reajuste', icono: 'bi bi-graph-up-arrow', base: '/reajuste' },
    { nombreBackend: 'RECONOCIMIENTO', label: 'Trámite Reconocimiento de Servicios', etiquetaCorta: 'Reconocimiento', icono: 'bi bi-award-fill', base: '/reconocimiento' },
    { nombreBackend: 'PNC', label: 'Trámite PNC', etiquetaCorta: 'PNC', icono: 'bi bi-file-earmark-medical', base: '/pnc' },
    { nombreBackend: 'AMPARO_PNC', label: 'Trámite Amparo PNC', etiquetaCorta: 'Amparo PNC', icono: 'bi bi-shield-exclamation', base: '/amparo-pnc' },
    // Variante de Amparo PNC (V256): misma ficha y mismo formulario, montados bajo su propia ruta.
    { nombreBackend: 'AMPARO_LEY_16986', label: 'Trámite Amparo Ley 16.986', etiquetaCorta: 'Amparo 16.986', icono: 'bi bi-shield-exclamation', base: '/amparo-ley-16986' },
    { nombreBackend: 'PENSION', label: 'Trámite Pensión', etiquetaCorta: 'Pensión', icono: 'bi bi-people', base: '/pension' },
    { nombreBackend: 'GANANCIAS', label: 'Trámite Impuesto a las Ganancias', etiquetaCorta: 'Ganancias', icono: 'bi bi-percent', base: '/ganancias' },
    { nombreBackend: 'MINUSVALIA', label: 'Trámite Minusvalía', etiquetaCorta: 'Minusvalía', icono: 'bi bi-person-wheelchair', base: '/minusvalia' },
    { nombreBackend: 'DECLARATORIA_HEREDEROS', label: 'Trámite Declaratoria de Herederos', etiquetaCorta: 'Declaratoria', icono: 'bi bi-diagram-3', base: '/declaratoria' },
    { nombreBackend: 'AMPARO', label: 'Trámite Amparo por Mora (ANSES)', etiquetaCorta: 'Amparo', icono: 'bi bi-shield-exclamation', base: '/amparo' },
    { nombreBackend: 'GENERICO', label: 'Otro trámite', etiquetaCorta: 'Otro', icono: 'bi bi-file-earmark-plus', base: '/generico' },
];

// Familia visual de cada tipo de trámite: el sufijo de la clase CSS (que define el color de la
// tarjeta, ver TramitesCliente.css) y el ícono. Los colores son los mismos que usa el carrusel de
// áreas del inicio: RTI azul, ART verde.
//
// Vive acá y no en la ficha del cliente porque la grilla de tarjetas se reusa también en la
// atención de turnos de cobro (VistaDetalladaAtencionCobro): es el mismo vocabulario de tipos que
// rutaDetalleTramite, con el mismo orden de chequeos.
//
// El orden de los chequeos importa: "Amparo PNC" tiene que caer en amparo (no en PNC), y el amparo
// por mora ante ANSES ('AMPARO' a secas, V239) en amparoanses — si se chequeara solo 'AMPARO', los
// dos compartirían tarjeta y no se distinguirían entre sí.
export function metaTramite(tipo) {
    const t = String(tipo || '').toUpperCase();
    if (t.includes('ART')) return { clave: 'art', icono: 'bi-heart-pulse-fill' };
    if (t.includes('RTI')) return { clave: 'rti', icono: 'bi-folder-fill' };
    if (t.includes('AMPARO') && (t.includes('PNC') || t.includes('16986'))) return { clave: 'amparo', icono: 'bi-shield-exclamation' };
    if (t.includes('AMPARO')) return { clave: 'amparoanses', icono: 'bi-shield-exclamation' };
    if (t.includes('JUBILACI')) return { clave: 'jubilacion', icono: 'bi-hourglass-split' };
    if (t.includes('RECONOCIMIENTO')) return { clave: 'reconocimiento', icono: 'bi-award-fill' };
    if (t.includes('REAJUSTE')) return { clave: 'reajuste', icono: 'bi-graph-up-arrow' };
    if (t.includes('PNC')) return { clave: 'pnc', icono: 'bi-shield-fill-plus' };
    if (t.includes('PENSI')) return { clave: 'pension', icono: 'bi-people-fill' };
    if (t.includes('GANANCIAS')) return { clave: 'ganancias', icono: 'bi-percent' };
    if (t.includes('MINUSVAL')) return { clave: 'minusvalia', icono: 'bi-person-wheelchair' };
    if (t.includes('DECLARATORIA')) return { clave: 'declaratoria', icono: 'bi-diagram-3' };
    if (t.includes('PUAM')) return { clave: 'puam', icono: 'bi-person-badge-fill' };
    if (t.includes('PLAN')) return { clave: 'planpago', icono: 'bi-cash-coin' };
    return { clave: 'otro', icono: 'bi-folder2-open' };
}

export function rutaIniciarTramite(nombreTipo, cuil) {
    const nombre = String(nombreTipo || '').trim().toUpperCase();
    const entrada = TIPOS_TRAMITE_PICKER.find((t) => t.nombreBackend === nombre);
    if (!entrada) return null;
    return cuil ? `${entrada.base}/tramites/iniciar-tramite/${cuil}` : `${entrada.base}/tramites/iniciar-tramite`;
}

// Mismo mapeo tipo -> ruta de detalle usado antes por separado en TramiteLegacyRedirect.js y
// VistaDetalladaCliente.js. Soporta ambas formas de "tramite":
// - TramiteListadoDto (listado unificado / paginado): tipoTramite es un STRING (nombre).
// - TramiteDto (detalle, getTramitePorId): tipoTramite es un OBJETO { nombre }.
export function rutaDetalleTramite(tramite) {
    const idTramite = tramite?.idTramite;
    const nombreTipo = String(
        tramite?.tipoTramite?.nombre ?? tramite?.nombreTipoTramite ?? tramite?.tipoTramite ?? ''
    ).toLowerCase();

    if (nombreTipo.includes('art')) return `/art/tramites/${idTramite}`;
    if (nombreTipo.includes('jubilaci')) return `/jubilacion/tramites/${idTramite}`;
    if (nombreTipo.includes('puam')) return `/puam/tramites/${idTramite}`;
    if (nombreTipo.includes('plan_pago') || nombreTipo.includes('plan de pago')) return `/plan-pago/tramites/${idTramite}`;
    if (nombreTipo.includes('reajuste')) return `/reajuste/tramites/${idTramite}`;
    if (nombreTipo.includes('reconocimiento')) return `/reconocimiento/tramites/${idTramite}`;
    // Los dos amparos van ANTES del genérico de PNC, porque "amparo_pnc" también contiene la
    // subcadena "pnc". Y entre ellos, el de PNC primero: "amparo_pnc" contiene "amparo", así que si
    // se chequeara 'amparo' a secas todos los amparos por mora ante ANSES (V239) abrirían la ficha
    // de Amparo PNC.
    // AMPARO_LEY_16986 (V256) también contiene "amparo": sin este chequeo abriría el amparo por mora.
    if (nombreTipo.includes('amparo') && nombreTipo.includes('16986')) return `/amparo-ley-16986/tramites/${idTramite}`;
    if (nombreTipo.includes('amparo') && nombreTipo.includes('pnc')) return `/amparo-pnc/tramites/${idTramite}`;
    if (nombreTipo.includes('amparo')) return `/amparo/tramites/${idTramite}`;
    if (nombreTipo.includes('pnc')) return `/pnc/tramites/${idTramite}`;
    // Va después de "reajuste": REAJUSTE_PENSION no es un tipotramite propio (es
    // tramite_reajuste.beneficio = PENSION dentro del módulo Reajuste), así que ya lo capturó
    // el check de arriba y nunca llega hasta acá.
    if (nombreTipo.includes('pension')) return `/pension/tramites/${idTramite}`;
    if (nombreTipo.includes('ganancias')) return `/ganancias/tramites/${idTramite}`;
    // Va antes del genérico y del fallback a RTI: "MINUSVALIA" es un tipo propio desde este módulo.
    if (nombreTipo.includes('minusval')) return `/minusvalia/tramites/${idTramite}`;
    // Va antes del genérico y del fallback a RTI: "DECLARATORIA_HEREDEROS" es un tipo propio.
    if (nombreTipo.includes('declaratoria')) return `/declaratoria/tramites/${idTramite}`;
    if (nombreTipo.includes('generico') || nombreTipo.includes('genérico')) return `/generico/tramites/${idTramite}`;

    return `/rti/tramites/${idTramite}`;
}
